import { createSlice } from "@reduxjs/toolkit";
import sha256 from "crypto-js/sha256";

export const appStateSlice = createSlice({
  name: "app",
  initialState: {
    view: "startup", // options: gridd, templates, startup, welcome
    readOnlyMode: false,
    lastMessage: null,
    styleSheetDialogOpen: false,
    styleSheetWizardOpen: false,
    modernDesign: true,
    preferencesDialogOpen: false,
    imageCropDialogOpen: false,
    copyPasteDialogOpen: false,
    parsedCopyPaste: null,
    welcomePopupOpen: false,
    dialogParams: null,
    lastOpenAccordionItem: "style",
    cellEditing: false,
    mousePosition: { x: 0, y: 0 },
    colorPickerOpen: false,
    currentSlideId: undefined,
    localStorageKey: null,
    lastSettings: {}, // example: shape: {...}, icon: {...}, etc.
    presentation: {
      hash: null,
    },
    cellOverflow: {}, // { [cellId]: overflowPx }
  },
  reducers: {
    toGridd: (state) => {
      state.view = "gridd";
    },
    toTemplates: (state, action) => {
      if (action.payload) {
        state.lastMessage = {
          griddContentExist: action.payload.griddContentExist,
          styleContentExist: action.payload.styleContentExist,
        };
      }
      state.view = "templates";
    },
    toStartUp: (state, action) => {
      if (action.payload) {
        state.currentSlideId = action.payload;
      } else state.currentSlideId = undefined;
      state.view = "startup";
    },
    openStyleSheetDialog: (state) => {
      state.styleSheetDialogOpen = true;
    },
    closeStyleSheetDialog: (state) => {
      state.styleSheetDialogOpen = false;
    },
    openStyleSheetWizard: (state) => {
      state.styleSheetWizardOpen = true;
    },
    closeStyleSheetWizard: (state) => {
      state.styleSheetWizardOpen = false;
    },
    toggleModernDesign: (state) => {
      state.modernDesign = !state.modernDesign;
    },
    openPreferencesDialog: (state) => {
      state.preferencesDialogOpen = true;
    },
    closePreferencesDialog: (state) => {
      state.preferencesDialogOpen = false;
    },
    openImageCropDialog: (state, action) => {
      if (action.payload) {
        state.dialogParams = { ...action.payload };
      }
      state.imageCropDialogOpen = true;
    },
    closeImageCropDialog: (state) => {
      state.imageCropDialogOpen = false;
    },
    openCopyPasteDialog: (state, action) => {
      state.copyPasteDialogOpen = true;
      state.parsedCopyPaste = action.payload;
    },
    closeCopyPasteDialog: (state) => {
      state.copyPasteDialogOpen = false;
    },
    setLastOpenAccordionItem: (state, action) => {
      state.lastOpenAccordionItem = action.payload;
    },
    setCellEditing: (state, action) => {
      state.cellEditing = action.payload;
    },
    setMousePosition: (state, action) => {
      state.mousePosition = action.payload;
    },
    openColorPicker: (state) => {
      state.colorPickerOpen = true;
    },
    closeColorPicker: (state) => {
      state.colorPickerOpen = false;
    },
    openWelcomePopup: (state) => {
      state.welcomePopupOpen = true;
    },
    closeWelcomePopup: (state) => {
      state.welcomePopupOpen = false;
    },
    storeLastSetting: (state, action) => {
      state.lastSettings = {
        ...state.lastSettings,
        ...action.payload,
      };
    },
    setPresentationId: (state, action) => {
      const presIdString = `${action.payload.presentationid}_${action.payload.slideId}`;
      state.presentation.hash = sha256(presIdString).toString();
    },
    setLocalStorageKey: (state, action) => {
      state.localStorageKey = action.payload;
    },
    setReadOnlyMode: (state, action) => {
      state.readOnlyMode = action.payload;
    },
    setCellOverflow: (state, action) => {
      state.cellOverflow = {
        ...state.cellOverflow,
        [action.payload.id]: {
          minimumWidth: action.payload.minimumWidth,
          contentHeight: action.payload.contentHeight,
          contentWidth: action.payload.contentWidth,
        },
      };
    },
  },
});

export const {
  toGridd,
  toTemplates,
  toStartUp,
  toWelcome,
  openStyleSheetDialog,
  closeStyleSheetDialog,
  openStyleSheetWizard,
  closeStyleSheetWizard,
  toggleModernDesign,
  openPreferencesDialog,
  closePreferencesDialog,
  openImageCropDialog,
  closeImageCropDialog,
  openCopyPasteDialog,
  closeCopyPasteDialog,
  setLastOpenAccordionItem,
  setCellEditing,
  setMousePosition,
  openColorPicker,
  closeColorPicker,
  openWelcomePopup,
  closeWelcomePopup,
  storeLastSetting,
  setPresentationId,
  setLocalStorageKey,
  setReadOnlyMode,
  setCellOverflow,
} = appStateSlice.actions;

export default appStateSlice.reducer;
